import { render, staticRenderFns } from "./PlanningBacklog.vue?vue&type=template&id=522e6892&scoped=true&"
import script from "./PlanningBacklog.vue?vue&type=script&lang=js&"
export * from "./PlanningBacklog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522e6892",
  null
  
)

export default component.exports